<template>

  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
  <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
  <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>

    <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont"> {{ $t('Current-Movements') }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field flat="" solo-inverted="" hide-details v-model="search" :label="$t('Search')" append-icon="search">
            </v-text-field>
            <!-- @click="carihareketEkle()" -->
            <v-tooltip bottom>
              <v-btn :disabled="!sayfayetki.Save" slot="activator"  flat> <span
                  class="hidden-sm-and-down"> {{ $t('Add') }}
                </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
              <span v-if="sayfayetki.Save">{{ $t('Add') }}</span>
            </v-tooltip>


          </v-toolbar>
        </v-flex>
        <v-container fluid>

        <v-layout row wrap>
          <v-flex xs12 sm6 md4>
          <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="refkod">
                                                        </referansmerkezicomp> </v-flex>
          <v-flex xs12 sm6 md4>
                <tarihim :etiket="$t('Starting-Date')" :detaygizle="false" v-model="CariHareketInput.BaslangicTarihi" v-bind:defaultvalue="'ok'"
                :rules="[v => !!v || $t('Please-select-a-date')]"></tarihim>
            </v-flex>
            <v-flex xs12 sm6 md4>
                <tarihim :etiket="$t('Starting-Date')" :detaygizle="false" v-model="CariHareketInput.BaslangicTarihi" v-bind:defaultvalue="'ok'"
                :rules="[v => !!v || $t('Please-select-a-date')]"></tarihim>
            </v-flex>

            <v-flex xs12 sm6 md4>
                <tarihim :etiket="$t('Starting-Date')" :detaygizle="false" v-model="CariHareketInput.BitisTarihi" v-bind:defaultvalue="'ok'"
                :rules="[v => !!v || $t('Please-select-a-date')]"></tarihim>
            </v-flex>

            <v-flex xs12 sm2 md2>
              <v-btn color="info" @click="CarihareketGetir()" fab small="" dark>
                <v-icon>search</v-icon>
              </v-btn>

              <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                @click.native="dialogfiltre=true" color="info" fab dark>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-flex>
           

        </v-layout>


        <v-layout row wrap mt-5>
   <v-data-table
    :headers="headers"
    :items="items"
    class="elevation-1"
  >
    <template v-slot:items="props">
      <td>{{ props.item.Cari.Kod }}</td>
      <td>{{ props.item.Cari.Unvan }}</td>
    </template>
  </v-data-table>

        </v-layout>
    </v-container>

    </v-layout>
  </div>
</template>

<script>
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp"
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import auth from "@/api/auth.js";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";

export default {

data(){
    return{
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: true,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      refkod:'',
      refad:'',
      loadingvmodel:false,
      snackbar:false,
      text1:null,
      items:[],
      headers:[{
        text:'Hesap',
        sortable:false
      },
       {
        text:'Unvan'
       } ],
      CariHareketInput: {
          SirketKodu: 1,
          BaslangicTarihi: null,
          BiletHaric: false,
          BitisTarihi: null,
          CariKodu: null,
          Filtreler: {
            Referans: null,
            Masraf: null,
            BaslangicTutar: 0,
            BitisTutar: 0,
            EvrakNo: null,
            EvrakTipi: null,
            FaturaNo: null,
          },
          Entegre: false,
          ListTipi: 0, // 0 : Hepsi, 1 : Bilet Kayıtları Hariç
        },
    }
},
components:{
    loadingcomp,
    snackbarcomp,
    yetkidialog,
    tarihim
},
methods:{
    CarihareketGetir(){
        this.loadingvmodel = true
        var Params = this.CariHareketInput
        this.$http.post(auth.API_URL + 'api/movement/index', Params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
          this.loadingvmodel = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service-'
            this.snackbar =true;
            this.loadingvmodel = false
          } else {
            this.text = 'Service-'
            this.snackbar =true;
            this.loadingvmodel = false
          }
        })

    }
},
mounted() {
    //this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    // if (this.sayfayetki.Status == true) {
    //   //YETKİ OK
    // this.CarihareketGetir();
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;
    //           window.open(url, "_self");
    //         } else {
    //           var mainUrl = "#/";
    //           window.open(mainUrl, "_self");
    //         }
    //       }
    //     });
    // }
  },
}
</script>
